import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfilePublications,
  ProfileContactSection,
} from './StaffProfileTemplate';

const JonathonKeatsProfile = () => {
  const person = {
    id: 'jonathon-keats',
    name: 'Jonathon Keats',
    honorific: null,
    title: 'Highland Fellow',
    affiliation: 'Experimental Philosopher, Artist, and Writer',
    image: 'https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/q8fso6b6_Jonathon%20Keats.jpg',
    email: 'KeatsJS@si.edu',
    category: 'Fellows & Visiting Scholars',
    testid: 'jonathon-keats-profile',
  };

  return (
    <StaffProfileTemplate person={person}>
      {/* Intellectual Biography */}
      <ProfileSection title="Intellectual Biography">
        <ProfileParagraphs
          items={[
            'Jonathon Keats is an experimental philosopher, artist, and writer who uses transdisciplinary projects to explore all aspects of society. He employs methods from both the sciences and the humanities in his work.',
            'His practice spans experimental philosophy, visual arts, and scholarly writing, engaging with questions of futures studies, climate adaptation, more-than-human governance, and the intersection of science, technology, art, and design.',
          ]}
        />
      </ProfileSection>

      {/* Current Positions & Affiliations */}
      <ProfileSection title="Current Positions & Affiliations">
        <ProfileBullets
          items={[
            'Research Associate, University of Arizona\'s College of Fine Arts',
            'Visiting Scholar, Metropolitan Autonomous University of Mexico City\'s UNESCO Chair in Futures Studies',
            'Lecturer, University of Colorado Boulder\'s Biofrontiers Institute',
            'Senior Fellow, San José State University\'s CADRE Laboratory for New Media',
            'Research Fellow, University of Zurich\'s School for Transdisciplinary Studies',
            'Artist Research Fellow, Berggruen Institute',
            'Research Fellow, Highland Institute',
            'Principal Philosopher, Long Now Foundation',
            'Artist-in-Residence, Smithsonian Institution\'s National Museum of Natural History',
            'Co-Director, Earth Law Center',
            'Artist-in-Residence, SETI Institute',
            'Artist-in-Residence, Biosphere 2',
            'Research Fellow, Fraunhofer Institute for Building Physics (Consortium for Climate-Adapted Architectural Heritage)',
          ]}
        />
      </ProfileSection>

      {/* Research Foci & Areas of Work */}
      <ProfileSection title="Research Foci & Areas of Work">
        <ProfileBullets
          items={[
            'Experimental philosophy',
            'Science and technology',
            'Art and design',
            'Futures studies',
            'Biofrontiers and new media',
            'Transdisciplinary studies',
            'Climate-adapted architectural heritage',
            'More-than-human governance',
          ]}
        />
      </ProfileSection>

      {/* Highland Institute Projects */}
      <ProfileSection title="Highland Institute Projects">
        <ProfileParagraphs
          items={[
            <>Jonathon Keats collaborates with The Highland Institute on the <em>Tasting Tomorrow</em> project, which explores the intersections of food, culture, and climate change through experimental and transdisciplinary approaches.</>,
          ]}
        />
      </ProfileSection>

      {/* Education */}
      <ProfileSection title="Education">
        <ProfileBullets
          items={[
            'BA in Philosophy and Interdisciplinary Studies, Amherst College (1994)',
          ]}
        />
      </ProfileSection>

      {/* Selected Publications & Knowledge Outputs */}
      <ProfileSection title="Selected Publications & Knowledge Outputs">
        <ProfilePublications
          items={[
            {
              year: 'Forthcoming',
              citation: (
                <>
                  <em>A Field Guide to More-Than-Human Governance</em>, Berggruen Press (2026).
                </>
              ),
            },
            {
              year: '2016',
              citation: (
                <>
                  <em>You Belong to the Universe: Buckminster Fuller and the Future</em>, Oxford University Press.
                </>
              ),
            },
            {
              year: '2013',
              citation: (
                <>
                  <em>Forged: Why Fakes Are The Great Art of Our Age</em>, Oxford University Press.
                </>
              ),
            },
            {
              year: '2010',
              citation: (
                <>
                  <em>Virtual Words: Language On The Edge Of Science And Technology</em>, Oxford University Press.
                </>
              ),
            },
            {
              year: '2009',
              citation: (
                <>
                  <em>The Book Of The Unknown: Tales Of The Thirty-Six</em>, Random House.
                </>
              ),
            },
          ]}
        />
        <ProfileParagraphs
          items={[
            <><em>Thought Experiments</em>, a monograph about his artwork, was published by Hirmer Verlag. He also writes a monthly online arts column for Forbes.</>,
          ]}
        />
      </ProfileSection>

      {/* Public Engagement, Teaching & Community Work */}
      <ProfileSection title="Public Engagement, Teaching & Community Work">
        <ProfileParagraphs
          items={[
            'Keats\'s transdisciplinary practice involves public engagement through exhibitions, experimental projects, and scholarly writing. His work at the Smithsonian Institution\'s National Museum of Natural History, SETI Institute, and Biosphere 2 reflects his commitment to bridging scientific inquiry with artistic exploration and public discourse.',
            'He is involved in the Consortium for Climate-Adapted Architectural Heritage at the Fraunhofer Institute for Building Physics, addressing the intersection of heritage preservation and climate adaptation.',
          ]}
        />
      </ProfileSection>

      {/* Contact & Scholarly Infrastructure */}
      <ProfileContactSection
        email={person.email}
        role="Experimental Philosopher, Artist, and Writer; Highland Fellow"
        testidPrefix="jonathon"
        scholarlyProfiles={[
          { label: 'Academia.edu', url: 'https://universityofarizona.academia.edu/JonathonKeats', testid: 'jonathon-academia-link' },
          { label: 'ORCID', url: 'https://orcid.org/0009-0009-0893-3757', testid: 'jonathon-orcid-link' },
        ]}
      />
    </StaffProfileTemplate>
  );
};

export default JonathonKeatsProfile;
